import React from 'react';
import { Check, CheckCheck, Clock, AlertTriangle } from 'lucide-react';
import { MESSAGE_STATUS_COLOR } from '@/utils/whatsappInbox';

interface StatusTicksProps {
  status: 'sending' | 'sent' | 'delivered' | 'read' | 'failed' | null;
}

/** WhatsApp-convention delivery ticks for an outbound message only —
 * inbound messages never show these (there's nothing "delivered" to us to report). */
const StatusTicks: React.FC<StatusTicksProps> = ({ status }) => {
  const color = MESSAGE_STATUS_COLOR[status || ''] || 'text-gray-400';
  if (!status || status === 'sending') return <Clock className={`w-3 h-3 ${color}`} />;
  if (status === 'failed') return <AlertTriangle className={`w-3 h-3 ${color}`} />;
  if (status === 'sent') return <Check className={`w-3.5 h-3.5 ${color}`} />;
  // delivered or read both use double-tick; read is the only one that turns blue.
  return <CheckCheck className={`w-3.5 h-3.5 ${color}`} />;
};

export default StatusTicks;
